import * as React from 'react';
import { CategoryLoopFunction, returnChild } from './category';
import { Group } from './categoriesGroup';
import { CategoryContext } from '../contexts';
import useHome from '../hooks/useHome';

export { Group };

type LoopProps = {
  children: CategoryLoopFunction | React.ReactNode;
};
/**
 * This loops over all the top level categories and repeats the children.
 * @param props For children you can pass JSX or a render prop.
 */
export const Loop = ({ children }: LoopProps) => {
  const home = useHome();
  if (!home || !home.categories) {
    return null;
  }
  const categories = home.categories || [];
  return (
    <>
      {categories.map((category, index) => (
        <CategoryContext.Provider key={category.id} value={category}>
          {returnChild(children, {
            category,
            index,
          })}
        </CategoryContext.Provider>
      ))}
    </>
  );
};
